// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// Components
import InputWrapper from '../InputWrapper';

// Types
import { formikInjectedPropsTypes } from '../../../../../lib/validation/propTypes/formikPropTypes';

/**
 * @visibleName Zip Code
 */
const InputZipCode = ({ className, ...props }) => (
  <InputWrapper
    {...props}
    type="tel"
    mask={[...Array(5)].map(() => /\d/)}
    className={classnames('input-zip-code', className)}
  />
);

InputZipCode.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  formikProps: formikInjectedPropsTypes.isRequired,
  label: PropTypes.string,
};

InputZipCode.defaultProps = {
  label: 'Zip Code',
  name: 'zipFive',
};

export default InputZipCode;
